var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.largeScreensClass},[_c('div',{ref:"mainAppDiv",staticClass:"fill-height",class:_vm.largeScreensClass},[_c('router-view')],1),(_vm.isTermsDialogVisible)?_c('TermsConditionsDialog'):_vm._e(),(_vm.isFAQDialogVisible)?_c('FAQDialog'):_vm._e(),_c('CookieConsent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }